import React, { useState } from 'react';
import { WMICMasterInput } from 'wmic-pe-components-platform-react';

const WMICMaskedInput = ({ maskChar = '*', unmaskedTrailingChars = 2, ...props }) => {
    const [isFocused, setIsFocused] = useState(false);

    const getMaskedValue = value => {
        if (!value) return '';

        const valueLength = value.length;
        if (valueLength <= unmaskedTrailingChars) return value;
        const maskedLength = valueLength - unmaskedTrailingChars;
        return maskChar.repeat(maskedLength) + value.slice(-unmaskedTrailingChars || valueLength);
    };

    const displayValue = isFocused ? props.value : getMaskedValue(props.value);

    return (
        <WMICMasterInput
            {...props}
            value={displayValue}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        />
    );
};

export default WMICMaskedInput;
